import React, { Component } from 'react';
import { Button, Row, Col, Icon } from "antd";
import { Link } from "react-router-dom";
import Colors from '../utils/Colors';

import CadastroRegistro from '../tutoriais/CadastroRegistro';
import OrdemServico from '../tutoriais/LancOrdemServico';
import Vendas from '../tutoriais/LancVendas';
import Pedidos from '../tutoriais/LancPedidos';

export default class extends Component {
    state = {
        modalOpen1: false,
        modalOpen2: false
    }

    render() {
        return (
            <div className="contentRoutesContainer">
                <span className="tituloPage">Ajuda (Tutoriais do Sistema)</span>
                <div className="divider-form" />
                <br />

                <Row>
                    <Link to="#" onClick={() => this.setState({ modalOpen1: true })} style={{ color: Colors.accentLight }}>
                        <span style={{ fontSize: 26 }}><Icon type='play-circle' />  Como Utilizar os cadastros do sistema</span>
                    </Link>
                </Row>
                <br />
                <Row>
                    <Link to="#" onClick={() => this.setState({ modalOpen2: true })} style={{ color: Colors.accentLight }}>
                        <span style={{ fontSize: 26, color: Colors.accentLight }}><Icon type='play-circle' />  Ordem de Serviço</span>
                    </Link>
                </Row>
                <br />
                <Row>
                    <Link to="#" onClick={() => this.setState({ modalOpen3: true })} style={{ color: Colors.accentLight }}>
                        <span style={{ fontSize: 26, color: Colors.accentLight }}><Icon type='play-circle' />  Gerenciar Vendas</span>
                    </Link>
                </Row>
                <br />
                <Row>
                    <Link to="#" onClick={() => this.setState({ modalOpen4: true })} style={{ color: Colors.accentLight }}>
                        <span style={{ fontSize: 26, color: Colors.accentLight }}><Icon type='play-circle' />  Pedidos</span>
                    </Link>
                </Row>




                <CadastroRegistro
                    isOpen={this.state.modalOpen1}
                    onClose={() => this.setState({ modalOpen1: false })}
                />
                <OrdemServico
                    isOpen={this.state.modalOpen2}
                    onClose={() => this.setState({ modalOpen2: false })}
                />
                <Vendas
                    isOpen={this.state.modalOpen3}
                    onClose={() => this.setState({ modalOpen3: false })}
                />
                <Pedidos
                    isOpen={this.state.modalOpen4}
                    onClose={() => this.setState({ modalOpen4: false })}
                />

            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/AjudasPage.js